import { PopupType } from '../../../utilities/constants/popup-type';

export const show = (
  popupType: PopupType,
  data?: Record<string, string | number | boolean>
) => {
  window.PopupMaker?.show(popupType, data);
};
